import React from 'react';
import bolexPic from '../assets/images/bolex.jpg'; 
import KennethRFN from '../assets/images/Kenneth Jaden Rob.jpg';
import './About.css'; 

function About() {
  return (
    <div className="about-container">
      <div className="about-images">
        <div className="about-image">
          <img src={KennethRFN} alt="Kenneth Nguyen" />
        </div>
        <div className="about-image">
          <img src={bolexPic} alt="Kenneth Nguyen" />
        </div>
      </div>
      <div className="about-links">
        <a href="mailto:kennethknguyen7@gmail.com">Email: kennethknguyen7@gmail.com</a>
      </div>
      <div className="about-content">
        <h3>ABOUT</h3>
        <p>
          Kenneth Nguyen is a filmmaker based in Herndon, Virginia and a Virginia Museum of Fine Arts (VMFA) Fellow. A 2026 graduate of the University of Virginia, he double majored in Film and Computer Science, a pairing that shapes his work across film and digital media. His narrative drama shorts have screened at festivals including the Tokyo International Short Film Festival, Virginia Film Festival, and Alexandria Film Festival. He has also collaborated with the Black & Indigenous Feminist Features Institute, V Magazine, UVA’s Karsh Institute, and The Moth: MainStage at the Paramount Theater. Kenneth continues to write and direct and is actively working on new projects.
        </p>

        <h3>AWARDS</h3>
        
          <p>Virginia Museum of Fine Arts Fellowship 2025-2026</p>
          <p>Virginia Film Festival 2026, <em>Official Selection</em> for "To Whom I Let Go"</p>
          <p>Alexandria Film Festival 2026, <em>Official Selection</em> for "To Whom I Let Go"</p>
          <p>Richmond Indie Film Festival 2025, <em>Official Selection</em> for "To Whom I Let Go"</p>
          <p>Tokyo International Short Film Festival 2024, <em>Official Selection</em> for “I See You”</p>
          <p>Cinéma Royale International Film Festival 2024, <em>Official Selection</em> for “I See You”</p>
        
      </div>
    </div>
  );
}

export default About;
